import { jsx as _jsx } from "react/jsx-runtime";
import { createPageComponent } from "../utils/createPageComponent";
import { BaseErrorPage } from "../components/BaseErrorPage";
import { GeneralErrorPageButtons } from "./Error5xxButtons";
const Page = () => (_jsx(BaseErrorPage, { titleTransKey: "generalError.title", infoTransKey: "generalError.info", buttons: _jsx(GeneralErrorPageButtons, {}) }));
export const GeneralErrorPage = createPageComponent(Page);
